import React, { useCallback } from 'react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { getMoreResults } from '../api';

const styles = {
  chip: {
    m: 1,
    fontSize: '14px',
    background: 'rgba(0, 117, 169, 0.2)',
    maxWidth: '250px',
    textOverflow: 'ellipsis',
    border: '1px solid transparent',
    '&: hover': {
      border: 1,
      borderColor: '#4e6b7c',
    },
  },
};

const Filter = props => {
  const { filter, setSelectedFilters, setData, setError, setLoading } = props;
  const { value, count, link } = filter || {};

  const handleFilterClick = useCallback(() => {
    setSelectedFilters(prev => [...prev, value]);

    setLoading(true);

    getMoreResults(link)
      .then(response => {
        const { facets, media, totalCount, next } = response.data;
        setData(prev => ({
          ...prev,
          facets,
          media,
          totalCount,
          next,
        }));
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [link, setData, setError, setLoading, setSelectedFilters, value]);

  return (
    <Box onClick={handleFilterClick} sx={{ cursor: 'pointer' }}>
      <Tooltip
        title={value}
        placement="top-end"
        arrow
        slotProps={{
          popper: {
            sx: {
              zIndex: 20000,
            },
          },
        }}
        disableHoverListener={value?.length < 30}
      >
        <Badge badgeContent={count} color="info" max={Infinity}>
          <Chip sx={styles.chip} label={value} />
        </Badge>
      </Tooltip>
    </Box>
  );
};

export default Filter;
